export default __webpack_public_path__ + "static/media/ic_kcc_24.b3ba53a7.svg";